import * as React from 'react';
import IFollowPost, { TFollowPost } from './IFollowPost';
import CompaniesPageService from '@services/CompaniesPage.service';
import ToolTip from '@appComponents/ToolTip/ToolTip';
import * as style from './FollowPostStyle.module.scss'

export default class FollowPost extends React.Component<IFollowPost, TFollowPost> {
  state: TFollowPost = {
    selected: this.props.subscribed,
    subscriptionId: this.props.subscription_id,
  };

  render() {
    const className = this.state.selected ? `fa-star ${style.following}` : 'fa-star-o';
    return (
      <ToolTip text={this.state.selected ? 'Unfollow this post' : 'Follow this post'}>
        <i
          className={[style.star, 'fa', className].join(' ')}
          onClick={() => this.follow()}
        />
      </ToolTip>
    );
  }

  follow = () => {
    CompaniesPageService.followPost(this.props.parentId, !this.state.selected, this.state.subscriptionId)
      .then((res) => {
        this.setState({ selected: !this.state.selected, subscriptionId: res.data.id });
      })
      .catch((error) => {
        console.log('followPost', { ...error });
      });
  }
}
